module.exports = __webpack_public_path__ + "33d67910ddc43d8e93fb4722d2398471.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/critical-strike.webm
// module id = 627
// module chunks = 0